<template>
  <el-dialog :title="`开票通知单（${formData.approvalNumber}）`" width="1000px" :visible="isShow" @close="handleCancel">
    <div class="openTickDetail">
      <el-form ref="form" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.orderNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                金税发票类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.invoiceTypeStr }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发票标记：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.invoiceMarkStr }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单客户编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.orderUnitCode }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单客户名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.orderUnit }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                税率：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.taxRate }}%
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                开票客户编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.kpOrderUnitCode }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                开票客户名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.kpOrderUnit }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                开票纳税人识别号：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.kpTaxpayerNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                纳税登记地址：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.taxRegistrationAddress }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                税务登记电话：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.taxRegistrationTelephone }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                开户行：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.bankDeposit }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                银行账号：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.bankAccount }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收函人：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.receiveUser }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收函人电话：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.receiveTelephone }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收函单位：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.receiveCompany }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收函地址：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.bankInfo && formData.bankInfo.receiveAddress }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                开票备注：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.remark }}
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发票接收邮箱：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.invoiceEmail }}
              </div>
            </div>
          </div>
          <div v-if="isReceipt" class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发票代码：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.invoiceCode }}
              </div>
            </div>
          </div>
        </div>

        <!-- 发票需要的模版 -->
        <div v-if="isReceipt">
          <div class="rj-row">
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  金税发票编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ formData.invoiceNo }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  金税发票日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ formData.invoiceDate }}
                </div>
              </div>
            </div>
          </div>

          <div class="rj-row">
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  快递单号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ formData.logisticsNo }}
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  出口发票号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ formData.exportInvoiceNo }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否整单开票：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.isAllInvoice ? '是' : '否' }}
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                附件：
              </div>
              <div v-if="formData.fileName !== '0'" class="rj-baseinfo__item is-blue" @click="downFile">
                {{ formData.fileName }}
              </div>
            </div>
          </div>
        </div>

        <div class="margin-10">
          <p class="mb-12">
            产品信息
          </p>
          <el-table
            :data="formData.productList"
            border
            style="width: 100%"
            show-summary
            sum-text="合计"
            :summary-method="handleTotal"
          >
            <el-table-column type="index" prop="index" label="序号" align="left" fixed="left" />
            <el-table-column prop="productCode" label="销售产品代码" width="100" align="left" fixed="left" />
            <el-table-column prop="productName" label="销售产品名称" width="220" align="left" />
            <el-table-column prop="productNum" label="数量" align="left" />
            <el-table-column prop="settlementUnitPrice" label="实际结算单价" width="100" align="right" header-align="left" />
            <el-table-column prop="settlementAmount" label="实际结算金额" width="120" align="right" header-align="left" />
            <el-table-column prop="amountExcludingTax" label="不含税金额" width="120" align="right" header-align="left" />
            <el-table-column prop="taxAmount" label="税额" align="right" header-align="left" width="120" />
            <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" width="180" align="left" />
            <el-table-column prop="agreedDeliveryDate" label="约定交付日期" width="180" align="left" />
            <el-table-column prop="taxRate" label="税率" align="right" header-align="left">
              <template v-slot="{row}">
                <span>{{ row.taxRate ? `${row.taxRate}%` : '' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="isApprove" class="margin-10">
          <p class="mb-12">
            历史审批意见：
          </p>
          <el-table :data="formData.approvalList" border style="width: 100%">
            <el-table-column prop="userName" label="审批人" align="left" />
            <el-table-column prop="approvalContent" label="审批内容" align="left" />
            <el-table-column prop="createTime" label="审批时间" align="left" />
            <el-table-column prop="agree" label="是否同意" align="left">
              <template v-slot="{row}">
                <span>{{ row.agree ? '同意' : '不同意' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="isApprove" class="margin-10">
          <p class="mb-12">
            审批意见：
          </p>
          <el-input v-model="ideaText" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="当驳回时审批意见为必填项" />
        </div>
      </el-form>
    </div>

    <div class="footer-btn">
      <el-button v-if="isReceipt" type="default" @click="handleCancel(0)">
        关闭
      </el-button>

      <el-button v-if="isApprove" type="default" @click="handleIdea(0)">
        驳 回
      </el-button>
      <el-button v-if="isApprove" type="primary" @click="handleIdea(1)">
        同 意
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { MathAdd } from '@/libs/util';
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => {}
    },
    isReceipt: { // 是否展示发票专属的内容
      type: Boolean,
      default: false
    },
    isApprove: { // 是否展示审批按钮
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      ideaState: 0,
      ideaText: '',
      invoiceTypeData: [
        { label: '增值税普通发票', value: 1 },
        { label: '增值税电子普通发票', value: 2 },
        { label: '增值税专用发票', value: 3 },
        { label: '出口发票', value: 4 }
      ],
      invoiceMarkData: [
        { label: '蓝字发票', value: 1 },
        { label: '红字发票', value: 2 }
      ]
    };
  },

  methods: {
    handleIdea (val) {
      this.ideaState = val;
      const params = {
        formData: this.formData,
        ideaText: this.ideaText,
        idea: val
      };
      this.$emit('handle-submit', params);
      this.ideaText = '';
    },

    // 产品信息合计
    handleTotal (params) {
      const { columns } = params;
      const tempTotal = ['合计'];
      columns.forEach((item, index) => {
        if (item.property === 'productNum') { // 数量
          tempTotal[index] = this.allAmount('productNum');
        } else if (item.property === 'settlementAmount') { // 实际结算金额
          tempTotal[index] = this.allAmount('settlementAmount');
        } else if (item.property === 'amountExcludingTax') { // 不含税金额
          tempTotal[index] = this.allAmount('amountExcludingTax');
        } else if (item.property === 'taxAmount') { // 税额
          tempTotal[index] = this.allAmount('taxAmount');
        }
      });
      return tempTotal;
    },

    allAmount (type) {
      let cont = 0;
      (this.formData.productList || []).forEach((item) => {
        cont = MathAdd(cont, item[type]);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },

    downFile () {
      this.$emit('down-file', this.formData);
    },

    handleCancel () {
      this.$emit('handle-cancel');
    }
  }

};
</script>

<style>
.margin-10 {
  margin: 10px 0;
}
.mb-12 {
  margin-bottom: 12px;
}
.is-blue {
  cursor: pointer;
  color: #3F9EF5;
}
</style>
